<template>
  <form-wizard
    ref="add_procurement_order_form"
    @on-complete="confirmation"
    enctype="multipart/form-data"
    color="#39C0ED"
  >
    <h2 slot="title"></h2>
    <tab-content title="Procurement Order">
      <item-card
        @data="dataItems"
        :procurement_order.sync="procurement_order"
        ref="childItemComponent"
      />
      <md-card style="z-index:0;">
        <!-- <md-card-header class="md-card-header-icon">
          <div class="card-icon">
            <md-icon>perm_identity</md-icon>
          </div>
          <h4 class="title">
                Add Procurement Order
              </h4>
        </md-card-header> -->
        <md-card-content>
          <div class="md-layout md-glutter" style="margin-bottom:20px;">
            <div class="md-layout-item md-small-size-100">
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:green">Remark</span>
            </label> -->
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <label for="">Remark</label>
                  <md-textarea
                    v-model="procurement_order.procurement_order_remark"
                    md-counter="100"
                    maxlength="100"
                    :readonly="procurement_order.procurement_order_status != 0"
                    md-autogrow
                  ></md-textarea>
                  <md-avatar >
                    <md-icon style="color:blue;">report</md-icon>
                    <md-tooltip md-direction="left">You can enter to add new row</md-tooltip>
                  </md-avatar>
                  <validation-error
                    :errors="apiValidationErrors.procurement_order_remark"
                  />
                </md-field>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
      
    </tab-content>
    <tab-content title="Attachments">
      <md-card>
        <!-- <md-card-header class="md-card-header-icon">
          <div class="card-icon">
            <md-icon>perm_identity</md-icon>
          </div>
          <h4 class="title">
            Edit Procurement Order
          </h4>
        </md-card-header> -->
        <md-card-content>
          <div
            v-if="procurement_order.procurement_order_status == 0"
            class="md-layout"
          >
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:green">Attach Quotation</span>
            </label> -->
            <div class="md-layout-item md-size-100">
              <span v-if="procurement_order.procurement_order_attach_quotation_url" style="color:green"
                >Current Document:
              </span>
              <a v-if="procurement_order.procurement_order_attach_quotation_url" :href="procurement_order.procurement_order_attach_quotation_url" target="_blank">
                    attach_quotation
                    </a>
              <!-- <a
                :href="
                  url_storage +
                    'po_attachment/' +
                    procurement_order.procurement_order_attach_folder +
                    '/' +
                    current_file_attach_quotation
                "
                target="_blank"
              >
                {{ current_file_attach_quotation }}
              </a> -->

              <md-field class="md-invalid">
                <label for="">Attach Quotation</label>
                <md-file
                 ref="attach_quotation"
                  @change="on_change_attach_quotation"
                  v-model="procurement_order.procurement_order_attach_quotation"
                  accept="image/jpeg,image/png,application/pdf,application/zip"
                />
                <validation-error
                  :errors="
                    apiValidationErrors.procurement_order_attach_quotation
                  "
                />
              </md-field>
              <div class="border p-2 mt-3">
                <template v-if="file_attach_quotation">
                  <img
                    v-if="
                      file_attach_quotation.type === 'image/jpeg' ||
                        file_attach_quotation.type === 'image/png'
                    "
                    :src="file_attach_quotation.base64"
                    class="img-fluid photo_list"
                  />
                  <!-- <p class="mb-0">
                    file name: {{ file_attach_quotation.name }}
                  </p> -->
                  <p class="mb-0">
                    size: {{ file_attach_quotation.size /1048576 }}MB
                  </p>
                </template>
              </div>
            </div>
          </div>

          <!-- <div
            v-if="procurement_order.procurement_order_status == 0"
            class="md-layout"
          >
            <div class="md-layout-item md-size-100">
              <span v-if="procurement_order.procurement_order_attach_po_url" style="color:green"
                >Current Document:
              </span>
              <a v-if="procurement_order.procurement_order_attach_po_url" :href="procurement_order.procurement_order_attach_po_url" target="_blank">
                    attach_po
                    </a>

              <md-field class="md-invalid">
                <label for="">Attach PO</label>
                <md-file
                 ref="attach_po"
                  @change="on_change_attach_po"
                  v-model="procurement_order.procurement_order_attach_po"
                  accept="image/jpeg,image/png,application/pdf"
                />
                <validation-error
                  :errors="apiValidationErrors.procurement_order_attach_po"
                />
              </md-field>
              <div class="border p-2 mt-3">
                <template v-if="file_attach_po">
                  <img
                    v-if="
                      file_attach_po.type === 'image/jpeg' ||
                        file_attach_po.type === 'image/png'
                    "
                    :src="file_attach_po.base64"
                    class="img-fluid"
                  />
                  <p class="mb-0">size: {{ (file_attach_po.size / 1048576).toFixed(2) }}MB</p>
                </template>
              </div>
            </div>
          </div> -->

          <!-- <div class="md-layout">
            <div class="md-layout-item">
              <span v-if="procurement_order.procurement_order_attach_invoice_url" style="color:green"
                >Current Document:
              </span>
              <a v-if="procurement_order.procurement_order_attach_invoice_url" :href="procurement_order.procurement_order_attach_invoice_url" target="_blank">
                    attach_invoice
                    </a>
            
              <md-field class="md-invalid">
                <label for="">Attach Invoice</label>
                <md-file
                  ref="attach_invoice"
                  @change="on_change_attach_invoice"
                  v-model="procurement_order.procurement_order_attach_invoice"
                  accept="image/jpeg,image/png,application/pdf"
                />
                <validation-error
                  :errors="apiValidationErrors.procurement_order_attach_invoice"
                />
              </md-field>
              <div class="border p-2 mt-3">
                <template v-if="file_attach_invoice">
                  <img
                    v-if="
                      file_attach_invoice.type === 'image/jpeg' ||
                        file_attach_invoice.type === 'image/png'
                    "
                    :src="file_attach_invoice.base64"
                    class="img-fluid"
                  />
                  <p class="mb-0">
                    size: {{ file_attach_invoice.size /1048576 }}MB
                  </p>
                </template>
              </div>
            </div>
          </div> -->

          <!-- <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <span v-if="procurement_order.procurement_order_attach_payment_url" style="color:green"
                >Current Document:
              </span>
               <a v-if="procurement_order.procurement_order_attach_payment_url" :href="procurement_order.procurement_order_attach_payment_url" target="_blank">
                    attach_payment
                    </a>
             
              
              <md-field class="md-invalid">
                <label for="">Attach Payment</label>
                <md-file
                ref="attach_payment"
                  @change="on_change_attach_payment"
                  v-model="procurement_order.procurement_order_attach_payment"
                  accept="image/jpeg,image/png,application/pdf"
                />
                <validation-error
                  :errors="apiValidationErrors.procurement_order_attach_payment"
                />
              </md-field>
              <div class="border p-2 mt-3">
                <template v-if="file_attach_payment">
                  <img
                    v-if="
                      file_attach_payment.type === 'image/jpeg' ||
                        file_attach_payment.type === 'image/png'
                    "
                    :src="file_attach_payment.base64"
                    class="img-fluid"
                  />
                  <p class="mb-0">
                    size: {{ file_attach_payment.size /1048576 }}MB
                  </p>
                </template>
              </div>
            </div>
          </div> -->
        </md-card-content>
      </md-card>
    </tab-content>
  </form-wizard>
</template>

<script>
import { ValidationError } from "@/components";
import { FormWizard, TabContent } from "vue-form-wizard";
import formMixin from "@/mixins/form-mixin";
import ItemCard from "@/pages/Dashboard/Workshop/ProcurementOrder/ComponentForm/ItemCard.vue";
import Swal from 'sweetalert2';

const url_storage = process.env.VUE_APP_STORAGE_BASE_URL;
//   const getUrlExtension = (url) => {
//     return url
//       .split(/[#?]/)[0]
//       .split(".")
//       .pop()
//       .trim();
//   }

//   const onImageEdit = async (imgUrl) => {
//     var imgExt = getUrlExtension(imgUrl);

//     const response = await fetch(imgUrl, {mode: 'cors'});
//     const blob = await response.blob();
//     const file = new File([blob], "profileImage." + imgExt, {
//       type: blob.type,
//     });
// }

export default {
  name: "edit-procurement-order",

  props: {
    data: Object,
    data_id:null,
  },

  components: {
    FormWizard,
    TabContent,
    ValidationError,
    "item-card": ItemCard,
  },

  mixins: [formMixin],

  data: () => ({
    url_storage: url_storage,
    procurement_order: [],
    current_file_attach_quotation: null,
    current_file_attach_po: null,
    current_file_attach_invoice: null,
    // current_file_attach_payment: null,
    file_attach_quotation: null,
    file_attach_po: null,
    file_attach_invoice: null,
    file_attach_payment: null,
  }),
  created() {
    this.getProcurementOrderData();
  },

 

    methods: {
      //fungsi ketika page dibuka
      async getProcurementOrderData(){
        //check apakah ada id di route
        if(this.data_id.id){

          //ambil data dari server berdasarkan id yang ada ikut dikirim di route
          await this.$store.dispatch("workshop_procurement_order/get", this.data_id.id)
          this.procurement_order = await await this.$store.getters["workshop_procurement_order/procurement_order"]
          //set nilai var berdasarkan data dari server
          // this.current_file_attach_quotation= this.procurement_order.procurement_order_attach_quotation
          // this.current_file_attach_po= this.procurement_order.procurement_order_attach_po
          // this.current_file_attach_invoice= this.procurement_order.procurement_order_attach_invoice
          // this.current_file_attach_payment= this.procurement_order.procurement_order_attach_payment

          //set null untuk semua var attach
          // this.procurement_order.procurement_order_attach_invoice = null;
          // this.procurement_order.procurement_order_attach_quotation= null;
          // this.procurement_order.procurement_order_attach_po = null;
          // this.procurement_order.procurement_order_attach_payment = null;

          //console.log(this.procurement_order)
          
          //butuh jeda time sebelum mengupdate value di chield client
          var self = this;
          setTimeout(function() {
            self.$refs.childItemComponent.getDataParent();
          }, 1);
        }
        else{
          //jika id tidak ada kembali ke list
          await this.$router.replace({name: 'List Procurement Order'});
        }
      },
      
      //fungsi kembali ke list
      backtoList(id) {
        this.$router.replace({ name: 'List Procurement Order' })
      },
      
      resetFile(ref) {
        this.$refs[ref].clearField()
      },

      //fungsi ketika ada perubahan di attach quotation
      on_change_attach_quotation: function(event) {
        var input = event.target
       if(!input.files[0] || (input.files[0].size / 1048576).toFixed(2) > 3){
          if(input.files[0]){
          this.sizeTobig(input.files[0].size) 
          }
          this.resetFile('attach_quotation')
          this.procurement_order.procurement_order_attach_quotation = null
          this.file_attach_quotation = null
          return
        }
        if (input.files) {
          this.readFile('attach_quotation',input)
        }
      },


    //fungsi ketika ada perubahan di attach po
      on_change_attach_po: function(event) {
        var input = event.target;
        if(!input.files[0] || (input.files[0].size / 1048576).toFixed(2) > 3){
          if(input.files[0]){
          this.sizeTobig(input.files[0].size) 
          }
          this.resetFile('attach_po')
          this.procurement_order.procurement_order_attach_po = null
          this.file_attach_po = null
          return
        }
        if (input.files) {
          this.readFile('attach_po',input)
        }
      },

      //fungsi ketika ada perubahan di attach invoice
      on_change_attach_invoice: function(event) {
        var input = event.target;
       if(!input.files[0] || (input.files[0].size / 1048576).toFixed(2) > 3){
          if(input.files[0]){
          this.sizeTobig(input.files[0].size) 
          }
          this.resetFile('attach_invoice')
          this.procurement_order.procurement_order_attach_invoice = null
          this.file_attach_invoice = null
          return
        }
        if (input.files) {
          this.readFile('attach_invoice',input)
        }
      },

      //fungsi ketika ada perubahan di attach payment
      // on_change_attach_payment: function(event) {
      //   var input = event.target;
      //  if(!input.files[0] || (input.files[0].size / 1048576).toFixed(2) > 3){
      //     if(input.files[0]){
      //     this.sizeTobig(input.files[0].size) 
      //     }
      //     this.resetFile('attach_payment')
      //     this.procurement_order.procurement_order_attach_payment = null
      //     this.file_attach_payment = null
      //     return
      //   }
      //   if (input.files) {
      //    this.readFile('attach_payment',input)
      //   }
      // },

    sizeTobig(size){
      Swal.fire({
          icon: 'error',
          title: 'File is to big ('+(size / 1048576).toFixed(2)+'MB)',
          text: 'Maximum attachment file size 3MB',
        })
    },


      //fungsi untuk membaca file
      readFile(type,input){
        var reader = new FileReader();
        //read file
          reader.onload = (e) => {
            //buat var dan isi nilainya
            const fileData = {
                  name: input.files[0].name,
                  size: input.files[0].size,
                  lastModified: input.files[0].lastModified,
                  lastModifiedDate: input.files[0].lastModifiedDate,
                  type: input.files[0].type,
                  base64: e.target.result
              }
              //isi nilai var sesuai type
              if(type == "attach_quotation"){
                this.file_attach_quotation = fileData
              }
              if(type == "attach_po"){
                this.file_attach_po = fileData
              }
              if(type == "attach_invoice"){
                this.file_attach_invoice = fileData
              }
              // if(type == "attach_payment"){
              //   this.file_attach_payment = fileData
              // }

            }
            reader.readAsDataURL(input.files[0]);
      },

       async confirmation() {
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.editProcurementOrder()
        }
      });
    },


      //fungsi mengirimkan data ke server
      async editProcurementOrder() {
        //panggil fungsi getdata di child untuk mendapatkan data didalam child tersebut
        this.$refs.childItemComponent.getData()
        //buat var data
        const data = {
          type: "workshop_procurement_orders",
          id : this.procurement_order.id,
          procurement_order_no : this.procurement_order.procurement_order_no,
          procurement_order_remark : this.procurement_order.procurement_order_remark,
          procurement_order_dealer_id: this.procurement_order.procurement_order_dealer_id,
          procurement_order_attach_quotation: this.file_attach_quotation,
          procurement_order_attach_po: this.file_attach_po,
          procurement_order_attach_invoice: this.file_attach_invoice, 
          // procurement_order_attach_payment: this.file_attach_payment,
          procurement_order_item: this.procurement_order.item
        }

        console.log(data)

        try {
           //kirim data add
        await this.$store.dispatch("workshop_procurement_order/update", data);
        //panggil alert sukses
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        //kembali ke list
        // await this.$router.replace({name: 'List Procurement Order'});
      this.$parent.$parent.modalCloseEdit();

      } catch (e) {
        //panggil alert error
        // await this.$store.dispatch(
        //   "alerts/error",
        //   "Oops, something went wrong"
        // );
        console.log(e);
        this.setApiValidation(e.response.data.errors);
      }

      },
       //fungsi untuk meyimpan data yang diambil dari fungsi getdata di child ketika di execute
      dataItems (value) {
        this.procurement_order.procurement_order_dealer_id = value.procurement_order_dealer_id
        this.procurement_order.item = value.item
      },
    },
  };
</script>
<style lang="scss" scoped>

.photo_list{
    max-width: 50%;
    height: auto;
    display: block;
    /* margin-left: auto;
    margin-right: auto; */
}

</style>

